<template>
  <div v-if="!error">
    <Overlay unique-key="yotpoQuestionsModal" mode="LIGHT">
      <LazyYotpoQuestionsAsk
        :yotpo-id="data.yotpoId"
        :product-name="data.name"
        :product-line-slug="data.productLineSlug"
      />
    </Overlay>

    <div class="relative mb-10">
      <div class="text-sm text-center mt-5 mb-5">{{ totalAnswers }} answered questions</div>
      <div class="flex justify-center lg:absolute lg:right-0 lg:-top-1/2">
        <button class="bg-black text-sm text-white px-6 py-2 rounded-full font-bold" @click="openQuestionsModal">
          Ask a question
        </button>
      </div>
    </div>

    <div v-if="questions.length > 0" :class="{ 'opacity-50': isLoading }">
      <template v-for="question in questions" :key="question.id">
        <YotpoQuestionsQuestion :question="question" />
      </template>
    </div>

    <div v-if="Math.ceil(totalAnswers / 5) > page" class="flex justify-center">
      <button class="bg-black text-white text-sm font-bold rounded-full m-12 px-6 py-2" @click="loadMore">
        Show more questions
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const { $sitewideConfig, $overlay } = useNuxtApp()
const { data } = defineProps<{
  data: ProductLine
}>()

const error = ref(false)
const isLoading = ref(false)
const questions = ref<YotpoQuestion[]>([])

const page = ref(1)
const totalAnswers = ref(0)

onMounted(() => {
  getQuestions()
})

function loadMore() {
  page.value++
  getQuestions(true)
}

async function getQuestions(loadMore = false) {
  if (isLoading.value) return
  isLoading.value = true

  try {
    const url = `https://api.yotpo.com/products/${$sitewideConfig.config.yotpoApiKey}/${data.yotpoId}/questions?per_page=5&page=${page.value}`

    const res = await $fetch<YotpoQuestionsResponse>(url, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })

    totalAnswers.value = res.response.total_answers
    // If we are loading more questions, we need to append the new questions to the existing questions
    questions.value = loadMore ? [...questions.value, ...res.response.questions] : res.response.questions
  } catch (err) {
    error.value = true
  } finally {
    isLoading.value = false
  }
}

function openQuestionsModal() {
  $overlay.open('yotpoQuestionsModal')
}
</script>
